"use strict";
var par = require("par");

module.exports = create_factory;

function create_factory(models, main) {
	return function (config, api, dispatcher) {
		var built_models = models.reduce(par(build, config, api, dispatcher), {});
		built_models.main = built_models[main];
		return built_models;
	};
}

function build(config, api, dispatcher, result, model) {
	var built_model = new model(api, dispatcher, config);

	result[built_model.name] = built_model;

	return result;
}
